<template>
	<div class="appointment-container-all">
		<div class="appointment-wrapper">
			<div class="header-appointment">
				<h4>{{ nameCompanie }}</h4>
			</div>
			<div class="swift-options">
				<button class="primero current" @click="change(1)" v-bind:style="{color : color_botones }">Crear Reservación</button>
				<button class="segundo blank" @click="change(2)" v-bind:style="{color : color_botones }">Mis reservas</button>
			</div>
			<div class="appoinment-information">
				<input type="date" class="fecha" autocomplete="off" placeholder="Fecha de reserva" @change="getDay(); this.className=(this.value!=''?'has-value':'')" v-model="form.fecha">
				<div class="avaliable-schedule" v-show="horas.length>0">
					<div class="header-avaliable">
						<h4>Horarios disponibles</h4>
					</div>
					<div v-for="(horas, index) in horas">
						<button :key="horas.id" :value="horas.id" @click="getHours(horas.id, index)" v-bind:id="'hour_'+index">{{horas.value}}</button>
					</div>
				</div>
				<input type="text" placeholder="Teléfono" v-model="form.telefono">
				<input type="text" placeholder="Número de personas" v-model="form.numero_persona"> 

                <div class="single-input" v-if="point.length>0">
					<select v-model="form.id_point" @change="getnumero()">
						<option disabled selected value="0">Seleccione el punto</option>
						<option v-for="point in point" :key="point.id_point" :value="point.id_point">{{ point.name }}</option>  
					</select>
				</div>
                <br>
				<div class="single-input" v-if="packages.length>0">
					<select @change="getPackage()" v-model="id_package">
						<option disabled selected value="0">Sin Paquete</option>
						<option v-for="packages in packages" :key="packages.id_packages" :value="packages.id_packages">{{ packages.nombre }} $ {{ new Intl.NumberFormat().format(packages.valor)}}</option>  
					</select>
				</div>
				<div class="multiple-select" v-if="schedule.length>0">
					<div class="single-item-select" v-for="schedule in schedule" v-bind:style="{backgroundColor : color_botones }">
						<i class="fas fa-times" @click="deletePackague(schedule)"></i>
						<span>{{ schedule.nombre }}</span>
					</div>
				</div>
				<div class="appoinment-button">
					<button @click="saveReserva()" v-bind:style="{backgroundColor : color_botones }" id="idbtn">Realizar reservación</button>
				</div>
			</div>
			<div class="my-appoinments">
				<div class="single-appointment" v-for=" reserva in reservation">
					<h4>Reserva #{{ reserva.id_reservations }}</h4>
					<h5 class="mt"><i class="far fa-clock"></i>{{ reserva.fecha.split(' ')[0]}} {{ reserva.hora }}</h5>
					<h5><i class="fas fa-map-pin"></i>{{ reserva.companies.name }}</h5>
					<h5><i class="fas fa-phone-alt"></i> {{ reserva.telefono }}</h5>
					<h5><i class="fa fa-info"></i> {{ reserva.tipos.name }}</h5>
					<div v-for="reservation_pack  in reserva.reservations_packages"><i class="fas fa-archive"></i>{{ reservation_pack.package.nombre }}</div>
					<div class="button-cancel-appointment" v-if="reserva.id_tipo_estado!=111">
						<button class="cancel" @click="editStatuReservation(reserva.id_reservations,111)">Cancelar</button>
					</div>
				</div>
			</div>
			<div class="schedule-success" v-show="exit_component">
				<div class="confirm-wrapper">
					<i id="id_icons"></i>
					<h4>{{ message }}</h4>
					<p>{{ message2 }}</p>
					<button @click="ConfirmPqr()" v-show="!state_btn">Cerrar</button>
                    <button @click="ClosePqr()" v-show="state_btn">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

	*{
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	*:focus{
		outline: none !important;
	}

	/*input[type="date"].has-value{
  		width: 100% !important;
		font-family: 'Poppins', sans-serif;
		border-radius: 10px;
		background: #F8F8FA;
		color: #868688;
		padding:17px 15px;
		border: none;
		margin-bottom: 15px;
	}

	input[type="date"]:not(.has-value):before{
 		content: attr(placeholder);
	}*/

	.fecha{
		-webkit-appearance: none !important;
	}

	@media only screen 
	  and (min-device-width: 375px) 
	  and (max-device-width: 667px) 
	  and (-webkit-min-device-pixel-ratio: 2) { 
	  	.fecha{
	  		width: 100vw !important;
	  		-webkit-appearance: none !important;
		}

		input[type="date"]:not(.has-value):before{
	 		content: attr(placeholder);
	 		width: 100vw !important;
		}
	}

	.modify{
		background: #F0F3FE;
		color: #23BEDD;
	}

	.cancel{
		background: #F8D7DA;
		color: #491217;
	}

	.mt{
		margin-top: 15px;
	}

	.button-cancel-appointment{
		width: 100%;
		height: auto;
		justify-content: space-between;
		align-items: center;
		padding: 15px 0px 5px 0px;
	}

	.button-cancel-appointment button{
		width: 49%;
		border: none;
		border-radius: 8px;
		padding: 10px 0px;
		font-family: 'Poppins', sans-serif;
		font-size: 14px;
	}

	.my-appoinments{
		width: 100%;
		height: auto;
		padding: 20px 0px;
		display: block;
	}

	.single-appointment{
		width: 100%;
		height: auto;
		border: 1px solid #ddd;
		padding: 15px 20px;
		border-radius: 15px;
		margin-bottom: 15px;
	}

	.single-appointment h4{
		font-family: 'Poppins', sans-serif;
		font-size: 19px;
		font-weight: 500;
	}

	.single-appointment h5{
		font-family: 'Poppins', sans-serif;
		font-size: 15px;
		font-weight: 500;
		margin-bottom: 10px;
	}

	.single-appointment i{
		margin-right: 10px;
		color: #22BCDC;
	}

	.header-avaliable{
		width: 100%;
		height: auto;
		padding: 0px 0px 10px 0px;
		text-align: left;
	}

	.appoinment-button{
		width: 100%;
		height: auto;
		text-align: center;
		padding: 25px 0px 0px 0px;
	}

	.appoinment-button button{
		width: 100%;
		height: auto;
		border: none;
		border-radius: 10px;
		padding: 15px 0px;
		color: #fff;
		font-family: 'Poppins', sans-serif;
		font-size: 16px;
		font-weight: 500;
		cursor: pointer;
	}

	.header-avaliable h4{
		font-family: 'Poppins', sans-serif;
		font-size: 14px;
		color: #B0B9C5;
		font-weight: 500;
	}

	.avaliable-schedule{
		width: 100%;
		margin-bottom: 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}

	.avaliable-schedule button{
		font-size: 11px;
		padding: 5px 13px;
		font-family: 'Poppins', sans-serif;
		margin-right: 15px;
		margin-bottom: 15px;
		border: none;
		border-radius: 5px;
	}

	/*.avaliable-schedule button:focus{
		background: #23BEDD;
		color: #fff;
	}*/

	.appoinment-information{
		width: 100%;
		text-align: left;
		height: auto;
		padding: 30px 0px;
		display: block;
	}

	.appoinment-information input{
		width: 100% !important;
		font-family: 'Poppins', sans-serif;
		border-radius: 10px;
		background: #F8F8FA;
		color: #868688;
		padding:17px 15px;
		border: none;
		margin-bottom: 15px;
	}

	.header-appointment{
		width: 100%;
		height: auto;
		text-align: center;
		margin-bottom: 15px;
	}

	.header-appointment h4{
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		font-size: 18px;
	}

	.appointment-container-all{
		width: 100%;
		height: auto;
		padding: 20px 15px;
		display: blok;
	}

	.swift-options{
		width: 98%;
		height: auto;
		border: 1px solid #F0F3FE;
		border-radius: 7px;
		padding: 6px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.swift-options button{
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		font-size: 14px;
		width: 49%;
		padding: 9px 0px;
		border-radius: 7px;
		border: none;
	}

	.current{
		background: #F7F8F9;
		/*color: #23BCDC;*/
	}

	.blank{
		background: transparent;
		/*color: #B5B5B5;*/
	}		

	.single-input{
		width: 100%;
	}

	.single-input select{
		width: 100%;
		padding: 17px;
		background: #F8F8FA;
		cursor: pointer;
		color: #868688;	
		border-radius: 5px;
		border: none;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 97%;
	  	background-position-y: 11px;
	  	font-family: 'Poppins', sans-serif;
		font-size: 14px;	
	}
	.multiple-select{
		width: 100%;
		height: auto;
		padding: 10px 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		border: 1px solid #ddd;
		margin-top: 15px;
		border-radius: 5px;
	}

	.single-item-select{
		padding: 5px 10px;
		/*background: #22BDDC;*/
		border-radius: 4px;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.single-item-select span{
		font-family: 'Poppins', sans-serif;
		font-size: 12px;
		font-weight: 500;
		color: #fff;
	}

	.single-item-select i{
		font-size: 11px;
		color: #fff;
		margin-right: 8px;
	}
	.schedule-success{
		width: 100%;
		height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .6);
	}

	.confirm-wrapper{
		width: 80%;
		background: #fff;
		padding: 20px 15px;
		border-radius: 10px;
		text-align: center;
		display: block;
	}

	.confirm-wrapper i{
		font-size: 65px;
		color: #22BDDC;
	}

	.confirm-wrapper h4{
		font-family: 'Poppins', sans-serif;
		margin-top: 7px;
		font-size: 16px;
		font-weight: 500;
	}

	.confirm-wrapper p{
		font-family: 'Poppins', sans-serif;
		margin-top: 4px;
		font-size: 12px;
		font-weight: 500;
	}

	.confirm-wrapper button{
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		font-size: 12px;
		width: 100%;
		padding: 9px 0px;
		border-radius: 7px;
		border: none;
		background: #F0F3FE;
		color: #23BCDC;
		margin-top: 15px;
	}
</style>

<script>
	import moment from 'moment';
	import axios from 'axios';
	import { osName } from 'mobile-device-detect';
	export default{
		data(){
			return{
				dias:[
				  'Domingo',
				  'Lunes',
				  'Martes',
				  'Miercoles',
				  'Jueves',
				  'Viernes',
				  'Sabado'
				],
				numeroDia: null,
				color_botones: "",
			    btnsave:true,
			    state_btn:false,
			    exit_component:false,
			    message:'',
                nameOS: osName,
			    mensaje:'',
			    message2:'',
			    nameCompanie:'',
			    puntero:false,
			   jornada:[{id:'PM',value:'PM'},{id:'AM',value:'AM'}],
			   horas:[],
			   packages:[],
			   point:[],
			   telefono_pedidos:'',
			   id_tipo_estado:'',
			   reservation:[],
			   schedule:[],
			   listSchedule:[],
			   phone:'',
			   id_package:0,
			   uri:'',
		       form:{
		        id_reservations:'',
		        numero_persona:'',
				telefono:'',
				id_point:0,
				package:[],
				numero_tabla:0,
				dia:'',
				hora:'',
				jornada:'',
				fecha:'',
				id_companie:''
                               }
			}
		},
		methods:{
			OpenPopup(msm,nameClass,msms=null){
		      this.message=msm
		      this.message2=msms
		      var clase=document.getElementById("id_icons");
		      console.log(clase)
		      if (clase)clase.className = nameClass;
		      this.exit_component=true
		    },
		    ClosePqr(){
		      this.exit_component=false
		    },
		    getnumero(){
                var self = this
		    	this.point.forEach((d)=>{
		    		if (self.form.id_point == d.id_point)self.telefono_pedidos = d.telefono_pedidos;
		    	})

		    },
		    ConfirmPqr(){
		      this.getReservationPhone()
		      this.exit_component=false
		    },
		    deletePackague(item){
		       this.schedule.splice(this.schedule.indexOf(item), 1);   
		    },
			getDay(){
		        this.setDisabled(false)    
		        axios
			      .get('https://back.vinapp.co/api/get-day-week/'+this.form.fecha)
			      .then(res => {
			      	console.log(res.data)
	                if (res.data) {
	                	this.form.dia= this.toSpanishDay(res.data.day);	                	
                        this.changeTime()
	                }
			      }).catch(err => {
			      	console.log(err)
			    });
				
				
			},
			getHours(hora, index){	
				var self = this;
				this.horas.forEach((item, pos) =>{
					document.getElementById(`hour_${pos}`).style.backgroundColor = "#F0EEEF";
					document.getElementById(`hour_${pos}`).style.color = "#000";
				});
				document.getElementById(`hour_${index}`).style.backgroundColor = this.color_botones;
				document.getElementById(`hour_${index}`).style.color = "#fff";	
              	this.form.hora=hora; 
			},
			getPackage(){
			  var self=this
              this.packages.forEach((detalle)=>{
              	if (detalle.id_packages==self.id_package) {
              		self.schedule.push(detalle)
              	}
              })
			},
			getEditReservations(id_reservations){
              axios
		      .get('https://back.vinapp.co/api/get-edit-reservations'+'/'+id_reservations)
		      .then(res => {
                if (res.data) {
                	var self=this
                	this.form=res.data
                	this.form.fecha=res.data.fecha.split(" ")[0];
                	res.data.reservations_packages.forEach((d)=>{
                        self.schedule.push(d.package)
                	})
                	this.puntero=true
                	this.change(1);
                }
		      }).catch(err => {

		      });
			},
			editarReserva(){
              //this.form.fecha=moment(this.form.fecha).format('YYYY-MM-DD HH:mm:ss');
	          this.form.package=JSON.stringify(this.schedule)
              axios
		      .post('https://back.vinapp.co/api/update-reservations',this.form)
		      .then(res => {
		      	if (res.data.statuCode==200) {
		      	  this.schedule=[]
		      	  this.phone=this.form.telefono
		      	  localStorage.setItem('phone',this.form.telefono)
		      	  this.form.numero_persona=0
		      	  this.state_btn=false
		      	  this.OpenPopup('Actualizacion Exitosa','fa fa-check','Ve al apartado de Mis reservas y confirma los datos de tu reservación.')
		      	}else{
		          this.state_btn=true
		      	  this.OpenPopup(res.data.message,'fa fa-window-close-o')
		      	}
		      }).catch(err => {
		      	this.state_btn=true
		      	this.OpenPopup(res.data.message,'fa fa-window-close-o')
		      });
			},
			changeTime(){
			  this.horas=[]
			  let puntero=true
			  this.btnsave=true
			  var self=this
			  if (this.listSchedule.length>0) {
                this.listSchedule.forEach((detalle)=>{
                   if(detalle.label==self.form.dia) {
                      if (detalle.desde && detalle.hasta) {
                          self.buildHour(detalle.desde,detalle.hasta)
                          puntero=false
                      }
                   }
                });
                if (puntero) {
                  this.btnsave=false
                   this.setDisabled(true)
                  this.state_btn=true
		      	  this.OpenPopup('Para esta fecha no tenemos horario disponible, prueba otra fecha, gracias.','fa fa-window-close-o')  	
                }
			  }else{
                this.state_btn=true
                this.setDisabled(true)
		      	this.OpenPopup('No hay disponibilidad de horario.','fa fa-window-close-o')
			  }
			},
			setDisabled(variable){
				setTimeout(function(){
		         var drinkSelect = document.getElementById('idbtn');
		         drinkSelect.disabled = variable; 
		        }, 500);
			},
			buildHour(desde,hasta){
                          let horaInicio=parseInt(desde.split(":")[0])
                          let mntInicio=parseInt(desde.split(":")[1])
                          let horaHasta=parseInt(hasta.split(":")[0])
                          let mntHasta=parseInt(hasta.split(":")[1])
                          var self=this
                          console.log(horaInicio,mntInicio,horaHasta,mntHasta)
                          if (horaInicio<horaHasta) {
                               for (var i = horaInicio; i<=horaHasta; i++) {
                                  self.horas.push({id:i+":00",value:i+":00"})
                                  self.horas.push({id:i+":30",value:i+":30"})
                                }
                           }
                           console.log(self.horas)
                        },
			getPackagesR(){
		      axios
		      .get('https://back.vinapp.co/api/list-package-true'+'/'+this.form.id_companie)
		      .then(res => {
                this.packages=res.data
		      }).catch(err => {
		      });
		    },
		    getReservationPhone(){
		      axios
		      .get('https://back.vinapp.co/api/list-reservations-phone'+'/'+this.phone+'/'+this.form.id_companie)
		      .then(res => {
                 this.reservation=res.data
		      }).catch(err => {
		      });
		    },
		    enviarWhatsApp(){
		       this.mensaje = '';
		       if (this.nameOS =='iOS') {
		          this.mensaje += `
		          whatsapp://send?phone=${this.telefono_pedidos}&text=Hola%20${this.nameCompanie}%20me%20gustaria%20hacer%20una%reservacion`;
		        }else{
		        this.mensaje += `
		          https://wa.me/${this.telefono_pedidos}?text=Hola%20${this.nameCompanie}%20me%20gustaria%20hacer%20una%reservacion`;
		        }
                      
			    this.mensaje += '%0A%0A';  
			    this.mensaje += `*Fecha:*%20${this.form.fecha}`;
			    this.mensaje += '%0A';//un espacio
			    this.mensaje +=  `*Hora:*%20${this.form.hora}`;  
			    this.mensaje += '%0A';//un espacio
			    this.mensaje +=  `*Telefono:*%20${this.form.telefono}`;
			    this.mensaje += '%0A';//un espacio
			    this.mensaje +=  `*Numero de persona:*%20${this.form.numero_persona}`;

			    this.mensaje += '%0A%0A';
			    this.mensaje += '*Paquete:*';
			    this.mensaje += '%0A';
                this.schedule.forEach((item)=>{
                	this.mensaje += `-%20${item.nombre}%20(%24%20${new Intl.NumberFormat("de-DE").format(item.valor)})`;
                	this.mensaje += '.%0A';
                });

                this.mensaje += '%0A';
                this.mensaje += `Gracias.`; 
			    
			    location.href = this.mensaje;
		    },
		    getCompaniesReservetion(){
		      axios
		      .get('https://back.vinapp.co/api/get-companies-reservetion'+'/'+this.uri)
		      .then(res => {
                if (res.data) {
         	 		this.form.id_companie=res.data.id_companie;
               		this.listSchedule=res.data.companie.schuedule;
                 	this.nameCompanie=res.data.companie.name;
                 	this.color_botones = res.data.color_botones;
                 	this.point = res.data.companie.points
         	 		this.getPackagesR()
         	 		if (localStorage.getItem('phone')) {
						this.phone=localStorage.getItem('phone')
						this.getReservationPhone()
					}
                }
		      }).catch(err => {
		      });
		    },
			toSpanishDay(day){
	          if(day == 'Sunday') return 'Domingo';
	          if(day == 'Monday') return 'Lunes';
	          if(day == 'Tuesday') return 'Martes';
	          if(day == 'Wednesday') return 'Miercoles';
	          if(day == 'Thursday') return 'Jueves';
	          if(day == 'Friday') return 'Viernes';
	          if(day == 'Saturday') return 'Sabado';
	        },
	        saveReserva(){
	          this.form.fecha=this.form.fecha+" 00:00:00";
	          this.form.package=JSON.stringify(this.schedule)
              axios
		      .post('https://back.vinapp.co/api/save-reservations',this.form)
		      .then(res => {
		      	if (res.data.statuCode==200) {
		      		/*this.horas = [];
		      	  	this.schedule=[]
		      	  	this.phone=this.form.telefono
		      	  	this.form.numero_persona=0
		      	  	this.id_package=''
		      	  	this.state_btn=false
		      	  	localStorage.setItem('phone',this.form.telefono)
		      	  	this.OpenPopup('Registro Exitoso','fa fa-check','Ve al apartado de Mis reservas y confirma los datos de tu reservación.')*/
		      	  	this.enviarWhatsApp()
		      	}else{
		      	  this.state_btn=true
		      	  this.OpenPopup(res.data.message,'fa fa-window-close-o')
		      	}
		      }).catch(err => {
		        this.state_btn=true
		      	this.OpenPopup(res.data.message,'fa fa-window-close-o')
		      });
	        },
	        editStatuReservation(id_reservations,id_tipo_estado){
              axios
		      .post('https://back.vinapp.co/api/edit-status-reservation',{
		      	id_reservations:id_reservations,
                id_tipo_estado:id_tipo_estado
               })
		      .then(res => {
                 this.getReservationPhone()
		      }).catch(err => {
		      });
	        },
			change(numero){
				if (numero == 1) {
					$(".primero").addClass("current");
					$(".primero").removeClass("blank");
					$(".segundo").removeClass("current");
					$(".segundo").addClass("blank");
					$(".appoinment-information").show();
					$(".my-appoinments").hide();	
				}else{
					$(".primero").removeClass("current");
					$(".primero").addClass("blank");
					$(".segundo").addClass("current");
					$(".segundo").removeClass("blank");
					$(".appoinment-information").hide();
					$(".my-appoinments").show();
				}	
			}
		},
		mounted(){
			if (this.$route.params.id) {
				this.uri=this.$route.params.id
				this.getCompaniesReservetion()
			}
			
			$(".my-appoinments").hide();
		}
	}
</script>